/* eslint-disable prettier/prettier */
/*
    public function show_Widerrufsbelehrung()
    {
        // Head
        $this->textflow = $this->pdf->add_textflow($this->textflow, "Widerrufsbelehrung", $this->boldOptions . " fillcolor=" . $this->colors->rgb->copy . $this->centeredAndUnderlined);
        $this->textflow = $this->pdf->add_textflow($this->textflow, "\n", $this->distanceOptions);
        $this->showWbChapter1();
        $this->showWbChapter2();
        $this->textflow = $this->pdf->add_textflow($this->textflow, "\nEnde der Widerrufsbelehrung\n", $this->boldOptions . " fillcolor=" . $this->colors->rgb->copy . $this->centeredAndNotUnderlined);
        $this->dumpThisTextflow();
    }
*/
import { wbChapter1 } from "./wbChapter1";
import { wbChapter2 } from "./wbChapter2";

const widerrufsbelehrung = {
    text: [
        {
            text: "Widerrufsbelehrung\n\n", style: "boldOptionsCenteredUnderlined"
        },
        wbChapter1,
        wbChapter2
    ],
    margin: [0, 20, 0, 0]
}

const wbEnde =
{
    text: "\nEnde der Widerrufsbelehrung\n", style: "boldOptions"
}

export { widerrufsbelehrung, wbEnde }